import { IConfigsType } from '../../types'

const demo: IConfigsType = {
  'fw_wingstop-customized-reports-7375b6fb': {
    '/:brand/forecast': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'fw_wingstop/forecast',
        height: '100vh',
      },
    },
  },
}

export default demo
